import { Modal, Spin } from '@ssar-app/uikit';

export const displayLoadingModal = (msg: string) => {
  const modal = Modal.info({
    icon: false,
    showFooterBtns: false,
    contentProps: { maxW: '50%' },
    bodyProps: { mt: 10, mb: 24 },
    content: <></>,
    closeOnOverlayClick: false,
  });
  modal.update({
    content: <Spin spinning tip={msg}></Spin>,
  });
  return modal.destroy;
};
